import { render, staticRenderFns } from "./MetaBallContainer.vue?vue&type=template&id=35586468&scoped=true&"
import script from "./MetaBallContainer.vue?vue&type=script&lang=js&"
export * from "./MetaBallContainer.vue?vue&type=script&lang=js&"
import style0 from "./MetaBallContainer.vue?vue&type=style&index=0&id=35586468&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35586468",
  null
  
)

export default component.exports